import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

const data = {
  entity: {
      id: 0,
      nombres: "",
      fechaIngreso: moment().format('yyyy-MM-DD'),
      razonSocial: "",
      idTipo: 0,
      tipo: "",
      idEstado: 0,
      fechaRegistro: null,
      usuarioRegistro: null,
      fechaModificacion: null,
      usuarioModificacion: null,
  },
  tipos: [{ id: 0, descripcion: "" }],
  validationActive: {
      razonSocial: false,
      idTipo: false,
      fechaIngreso: false,
  },
  validationMessage: [],
  personList: {
    id: 0,
    nombres: "",
  },
}

export const personLegalSlice = createSlice({
  name: "personLegal",
  initialState: {},
  reducers: {
    initPerson: (state, action) => {
      const { sliceKey } = action.payload;
      if (!state[sliceKey]) state[sliceKey] = structuredClone(data);
    },
    setEntity: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].entity = data;
    },
    setValueEntity: (state, action) => {
      var { sliceKey, name, value } = action.payload;
      console.log(sliceKey, name, value)
      if (name.startsWith("id")) value = parseInt(value)
      
      state[sliceKey].entity[name] = value
      state[sliceKey].validationActive[name] = true
    },
    setTipos: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].tipos = data;
    },
    setValidations: (state, action) => {
      const {sliceKey, message} = action.payload;
      state[sliceKey].validationMessage = message;
    },
    activeValidationsPersonaJuridica: (state, action) => {
      const {sliceKey} = action.payload;
      Object.keys(state[sliceKey].validationActive).forEach(function (key) {
        state[sliceKey].validationActive[key] = true;
      })
    },
    setPersonList: (state, action) => {
      const {sliceKey, data} = action.payload;
      state[sliceKey].personList = data;
    },
  },
});

export const { initPerson, setEntity, setValueEntity
  , setTipos, setPersonList
  , setValidations, activeValidationsPersonaJuridica
  } = personLegalSlice.actions;
export const defaultEntity = {
    id: 0,
    nombres: "",
    fechaIngreso: moment().format('yyyy-MM-DD'),
    razonSocial: "",
    idTipo: 0,
    tipo: "",
    idEstado: 0,
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
}
export default personLegalSlice.reducer;
